<div class="row">
    <div class="col-4">
        <rask-input-number
            class="w-100"
            label="Nettoareal, ha"
            [(ngModel)]="skogsvardsAtgard.nettoareal"
            [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
            (change)="onNettoarealChanged($event)"
            inputGroupRight="ha"
            [isNegative]="false"
            [inputProcessor]="numberDecimalProcessor">
        </rask-input-number>
    </div>
    @if(isFristaendeSiktrojning$ | async){
    <div class="col-4">
        <rask-simple-selector
            class="w-100"
            #efterfoljandeAtgard
            label="Efterföljande åtgärd"
            [values]="efterfoljandeAtgardValues()"
            [ngModel]="skogsvardsAtgard.efterfoljandeAtgard"
            (change)="onEfterfoljandeAtgardChaged(efterfoljandeAtgard.value)"
            [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
            raskVirkeskopRule
            [messageId]="['efterfoljandeAtgard']"
            [clearable]="true">
        </rask-simple-selector>
    </div>
    }
</div>